var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import api from '../api';
import config from '@/config';
export const TaskflowBillingContext = React.createContext(null);
const TaskflowBillingProvider = ({ children }) => {
    const [cache, setCache] = useState(null);
    useEffect(() => {
        let isMounted = true;
        const cancelToken = Axios.CancelToken.source();
        api.base
            .get(`${config.appUrls.api}/api/InvoiceSchedule/TaskflowSubtasks`, {
            cancelToken: cancelToken.token,
        })
            .then(({ data }) => {
            if (isMounted)
                setCache(data || {});
        }, () => {
            //Ignore errors
            if (isMounted)
                setCache({});
        });
        return () => {
            isMounted = false;
            if (cancelToken)
                cancelToken.cancel('Operation canceled due to new request.');
        };
    }, []);
    const hasTaskflowBilling = useCallback((invoiceScheduleId, subtaskTemplateId) => {
        if (!cache || !invoiceScheduleId || !subtaskTemplateId)
            return false;
        const subtasks = cache[invoiceScheduleId];
        if (!subtasks)
            return false;
        return subtasks.indexOf(subtaskTemplateId) >= 0;
    }, [cache]);
    const value = useMemo(() => ({
        hasTaskflowBilling,
    }), [hasTaskflowBilling]);
    return (_jsx(TaskflowBillingContext.Provider, Object.assign({ value: value }, { children: children })));
};
export const useHasTaskflowBilling = (invoiceScheduleId, subtaskTemplateId) => {
    const ctx = useContext(TaskflowBillingContext);
    if (!ctx) {
        console.warn('TaskflowBillingContext not provided');
        return false;
    }
    return useMemo(() => ctx.hasTaskflowBilling(invoiceScheduleId, subtaskTemplateId), [
        invoiceScheduleId,
        subtaskTemplateId,
        ctx,
    ]);
};
export const withTaskflowBillingProvider = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(TaskflowBillingProvider, { children: _jsx(Component, Object.assign({}, passThroughProps)) }));
};
